// Large values read as 340.1M / 44.3K; small values such as Cores/kDAU keep two decimals.
const compactFormatter = new Intl.NumberFormat('en-US', {
    notation: 'compact',
    compactDisplay: 'short',
    maximumFractionDigits: 1,
});

const preciseFormatter = new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 });

const fullFormatter = new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 });

export function formatReadableNumber(value: number): string {
    if (!Number.isFinite(value)) {
        return String(value);
    }

    return Math.abs(value) >= 1000 ? compactFormatter.format(value) : preciseFormatter.format(value);
}

// The exact value, used for hover text so nothing is lost by the short form.
export function formatFullNumber(value: number): string {
    return fullFormatter.format(value);
}
